import React from "react";
import cx from "./cx";

const VARIANT_CLASS = {
    primary: 'rev-btn--primary',
    secondary: 'rev-btn--secondary',
    subtle: 'rev-btn--subtle',
    danger: 'rev-btn--danger',
};

/**
 * Botón del DS. Renderiza `<button type="button">` salvo que se indique otro
 * `type` o un `as` distinto (Link, 'label', 'a'…).
 *  - variant: 'primary' | 'secondary' | 'subtle' | 'danger' | undefined (neutro)
 *  - size: 'sm'
 *  - icon: botón cuadrado solo-icono
 *  - fit: ancho al contenido (para <label> que actúa de botón)
 *  - loading: antepone el spinner .rev-spin y deshabilita
 */
const RevButton = ({ as: As = 'button', variant, size, icon, fit, loading, className, children, type, disabled, ...rest }) => {
    const classes = cx(
        'rev-btn',
        VARIANT_CLASS[variant],
        size === 'sm' && 'rev-btn--sm',
        icon && 'rev-btn--icon',
        fit && 'rev-btn--fit',
        className,
    );
    const buttonProps = As === 'button' ? { type: type || 'button', disabled: disabled || (loading ? true : undefined) } : {};
    return (
        <As className={classes} {...buttonProps} {...rest}>
            {loading && <span className="rev-spin" />}
            {children}
        </As>
    );
};

export default RevButton;
